(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('FacebookService', FacebookService);

  FacebookService.$inject = ['$resource'];

  function FacebookService ($resource) {
    return $resource(apiUrl + '/facebook/:id', { id: '@id' }, {
      'all': { url: apiUrl + '/facebook-all', method: 'GET', params: {}, isArray: true },
      'pages': { method: 'GET', params: {}, isArray: true },
      'subscribe': { method: 'POST', params: {}, isArray: false },
      'update': { method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      'remove': { method: 'DELETE' }
    });
  }
})();
